'use client';

import React from 'react';
import Link from 'next/link';
import ProductCard from '@/components/ProductCard';
import { getPreorderProducts } from '@/lib/products';
import { useI18n } from '@/i18n/LocaleProvider';
import { localizeProduct } from '@/i18n/products';

export default function PreordersContent() {
  const { locale, t } = useI18n();
  const products = getPreorderProducts()
    .map((p) => localizeProduct(p, locale))
    .sort((a, b) => a.preorder!.releaseDate.localeCompare(b.preorder!.releaseDate));

  return (
    <main className="pt-36 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <span className="text-xs font-bold tracking-widest uppercase text-accent mb-2 block">{t.preorders.eyebrow}</span>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-foreground mb-3">{t.preorders.title}</h1>
        <p className="text-muted-foreground text-base max-w-2xl mb-10">{t.preorders.body}</p>

        {products.length === 0 ? (
          <div className="text-center py-20 glass-card rounded-2xl">
            <p className="text-2xl font-bold text-foreground mb-2">{t.preorders.emptyTitle}</p>
            <p className="text-muted-foreground mb-6">{t.preorders.emptyBody}</p>
            <Link href="/category" className="text-primary hover:text-accent transition-colors font-semibold">
              {t.common.browseAllTcgs} →
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
